const mEditionProductDiscountCodesModalDelete = {
  mEditionProductDiscountCodesModalDelete: {
    alerts: {
      deleteProductoCuponDescuento: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El código de descuento se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el código de descuento',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Código'
  }
}

export default mEditionProductDiscountCodesModalDelete
